import React, { useCallback, useEffect, useState } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  APP_URL,
  AUTH_ERR_MSG,
  CFCProps,
  USERSROLE,
  LOCAL_STORAGE_KEYS
} from 'types';
import { RootState } from 'redux/root.reducer';
import {
  Button,
  Loading,
  RadioButton,
  RadioButtonGroup
} from 'carbon-components-react';
import { ButtonContent } from 'components';
import {
  selectIsAuthenticated,
  currentUser as selectCurrentUser
} from 'redux/session/selectors';
import { fetchSelectSessionOrgRole } from 'redux/auth/action';
import { fetchUserStart } from 'redux/user/actions';
import Service from 'services';
import { GenericPageLayout } from 'layouts/genericPage.layout';
import { Multitask } from '@carbon/pictograms-react';
import { redirectResidentialEnquirerIfNeeded } from 'utilities/residential-redirect.util';

export const MultiOrgSignInPanel: React.FC<Props> = (props: Props) => {
  const { loginType, userRole } = props.app;
  const { redirectPath } = props.session;
  const { error, submitting, isOTPActivated }: any = props.login;
  const dispatch = useDispatch();
  const [organisations, setOrganisations] = useState<Object[]>([]);
  const [organisationId, setOrganisationId] = useState<number>();
  const gwtToken = localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_JWT_TOKEN_ID);

  // EFFECTS :: TODO::
  const history = useHistory();
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    //if (gwtToken) {
    dispatch(fetchUserStart());
    // }
  }, [dispatch, gwtToken]);

  useEffect(() => {
    error?.Organisations && setOrganisations(error.Organisations || []);

    const renderLoginPage =
      (loginType === null && userRole === USERSROLE.OTHER) || false;
    const renderDashboradPage =
      (isAuthenticated && loginType !== null && !error) || false;
    const renderTermsPage =
      error?.message === AUTH_ERR_MSG.USER_ACCEPT_TERMS || false;

    //Redirect
    if (renderDashboradPage) {
      if (
        redirectResidentialEnquirerIfNeeded(userRole, currentUser, redirectPath)
      ) {
        return;
      }
      if (redirectPath) {
        history.push(redirectPath);
        return;
      }
      history.push(APP_URL.DASHBOARD);
      return;
    }
    renderTermsPage && history.push(APP_URL.AUTH_USER_TERMS);
    renderLoginPage && history.push(APP_URL.LOGIN);
  }, [
    history,
    isAuthenticated,
    loginType,
    userRole,
    error,
    redirectPath,
    currentUser
  ]);

  const finishSignInHandler = async () => {
    // TODO:: set org id
    organisationId && dispatch(fetchSelectSessionOrgRole(organisationId));
  };
  const handleLogout = useCallback(async () => {
    await Service.auth.ssoLogout();
  }, []);

  return (
    <div id="multi-org" className="multi-org" data-testid="multiOrg">
      <GenericPageLayout
        hideAnnouncements={true}
        pageClassName="multi-org--wrapper"
        isOTPActivated={isOTPActivated}
        showOTPNotification={false}
        bodyFooterIcon={<Multitask />}
      >
        {organisations?.length > 0 ? (
          <>
            <h1 className="multi-org--heading">Choose organisation role</h1>
            <RadioButtonGroup
              className="multi-org--selectRole"
              labelPosition="right"
              defaultSelected=""
              name="radio-button-group"
              valueSelected=""
              onChange={(val: any) => setOrganisationId(val)}
            >
              {organisations.map((item: any, id: number) => (
                <RadioButton
                  key={id}
                  id={`org_${id}`}
                  labelText={`${item.name}${
                    item.utilityId ? ` (${item.utilityId})` : ''
                  }`}
                  value={item.id}
                />
              ))}
            </RadioButtonGroup>
            <div className="multi-org--buttons">
              <Button
                kind="tertiary"
                className="multi-org--btn-sign-out"
                onClick={() => handleLogout()}
                area-label="Sign out"
              >
                Sign out
              </Button>
              <Button
                className="multi-org--btn-sign-finish"
                kind="primary"
                disabled={organisationId === undefined || submitting}
                data-testid="submit"
                onClick={() => finishSignInHandler()}
              >
                <ButtonContent isLoading={submitting}>
                  Finish sign-in
                </ButtonContent>
              </Button>
            </div>
          </>
        ) : (
          <div className="loader--wrapper">
            <Loading
              className="panelLoader"
              description="Active loading indicator"
              withOverlay={false}
            />
          </div>
        )}
      </GenericPageLayout>
    </div>
  );
};

const mapStateToProps = ({ app, session, login }: RootState) => ({
  app,
  session,
  login
});

const connector = connect(mapStateToProps);

type Props = CFCProps<typeof connector>;

MultiOrgSignInPanel.displayName = 'MultiOrgSignInPanel';

export default connector(MultiOrgSignInPanel);
